import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactCrop, { makeAspectCrop } from 'react-image-crop';
import { Button } from 'semantic-ui-react';
import { map } from 'lodash';
import 'react-image-crop/dist/ReactCrop.css';

class ImageCropper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      src: window.URL.createObjectURL(props.file),
      image: null,
      fileType: props.file.type,
      crop: {},
      pixelCrop: {}
    };
  }

  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
  }

  setCrops = aspect => {
    const { image } = this.state;

    const crop = aspect
      ? makeAspectCrop(
        {
          x: 0,
          y: 0,
          aspect,
          width: 50
        },
        image.width / image.height
      )
      : {
        x: 0,
        y: 0,
        aspect: null,
        width: 100,
        height: 100
      };

    this.setState({
      crop,
      pixelCrop: {
        x: Math.round(image.naturalWidth * (crop.x / 100)),
        y: Math.round(image.naturalHeight * (crop.y / 100)),
        width: Math.round(image.naturalWidth * (crop.width / 100)),
        height: Math.round(image.naturalHeight * (crop.height / 100))
      }
    });
  };

  getAspectByRatio = ratio => {
    const isReg = /^\d+:\d+$/.test(ratio);
    if (isReg) {
      let [widthR, heightR] = ratio.split(':');

      widthR = parseInt(widthR, 10);
      heightR = parseInt(heightR, 10);

      if (!Number.isNaN(widthR) && !Number.isNaN(heightR)) {
        // const fullKey = (widthR >= heightR) ? 'width' : 'height';
        return widthR / heightR;
      }
    }

    return null;
  };

  getCroppedImg = async () => {
    const { image, pixelCrop, fileType } = this.state;

    const canvas = document.createElement('canvas');
    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height
    );

    // As Base64 string
    // const base64Image = canvas.toDataURL('image/jpeg');

    // console.log(canvas.toDataURL(fileType));
    // As a blob
    const croppedFile = await new Promise(resolve => {
      const type = fileType === 'image/svg+xml' ? 'image/png' : fileType;
      canvas.toBlob(file => {
        const f = file;
        const isSvg = this.props.file.name.split('.').pop();
        if (isSvg === 'svg') {
          const name = this.props.file.name.split('.').shift();
          f.name = `${name}.png`;
          resolve(f);
        } else {
          f.name = this.props.file.name;
          resolve(f);
        }
      }, type);
    });

    return croppedFile;
  };

  handleChange = (crop, pixelCrop) => {
    this.setState({ crop, pixelCrop });
  };

  handleImageLoaded = image => {
    const ratio = this.props.cropRatios[0] ? this.props.cropRatios[0] : null;

    const aspect = this.getAspectByRatio(ratio);

    this.setState({ image }, () => this.setCrops(aspect));
    return false;
  };

  handleChangeRatio = ratio => {
    const aspect = this.getAspectByRatio(ratio);

    this.setCrops(aspect);
  };

  render() {
    const { crop, src, fileType } = this.state;
    const { cropRatios } = this.props;

    return (
      <Fragment>
        <ReactCrop
          src={src}
          crop={crop}
          onImageLoaded={this.handleImageLoaded}
          onChange={this.handleChange}
          keepSelection
          style={
            fileType === 'image/svg+xml' ? { width: '180px' }
              : { width: 'auto', height: 'auto' }}
        />
        <div className='reactCrop_ratio'>
          {map(cropRatios, (ratio, index) => (
            <Button
              basic
              color='blue'
              type='button'
              key={index}
              onClick={() => this.handleChangeRatio(ratio)}
            >
              {ratio}
            </Button>
          ))}
        </div>
      </Fragment>
    );
  }
}

ImageCropper.propTypes = {
  cropRatios: PropTypes.arrayOf(PropTypes.string),
  file: PropTypes.shape({
    name: PropTypes.string,
    size: PropTypes.number,
    type: PropTypes.string
  }).isRequired
};

ImageCropper.defaultProps = {
  cropRatios: []
};

export default ImageCropper;



// WEBPACK FOOTER //
// ./src/components/uploader/ImageCropper.js